export default __webpack_public_path__ + "static/media/Danielle_Kayembe_AHV_In_Moms_We_Trust.4b397f53.jpg";